import { put, call, select, takeLatest } from 'redux-saga/effects';
import { insertsActions as actions, insertsActions } from '.';
import { PayloadAction } from '@reduxjs/toolkit';
import { transformInsertsDTO } from './utils';
import {
  selectCustomerNumber,
  selectLanguageId,
} from 'app/features/erpSystem/slice/selectors';
import { erpalPayloadDTO } from '../../price/slice/utils';
import { selectErpSystem } from 'app/features/erpSystem/slice/selectors';
import { selectStoreId } from 'app/features/salesOrganisation/slice/selectors';

function* setInserts(action: PayloadAction<any>) {
  const inserts = action.payload;
  const { setInsertsSuccess, setInsertsFailure } = insertsActions;

  try {
    if (inserts.length > 0) {
      const customerNumber = yield select(selectCustomerNumber);
      const languageId = yield select(selectLanguageId);
      const erpSystem = yield select(selectErpSystem);
      const storeId = yield select(selectStoreId);

      const insertsTransformed = yield erpalPayloadDTO(action.payload);
      const shopId = storeId % 10; // Get last digit of store id Ex: 100001  => 1

      const insertsPriceResponse = yield call(
        fetch,
        `/valve-configurator/api/price?customerNumber=${customerNumber}&shopId=${shopId}&currency=EUR&languageId=${languageId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(insertsTransformed),
        },
      );
      const insertsPrice = yield insertsPriceResponse.json();

      const insertsStockResponse = yield call(
        fetch,
        `/valve-configurator/api/stockStatus?erpSystem=${erpSystem}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(insertsTransformed),
        },
      );
      const insertsStockStatus = yield insertsStockResponse.json();

      return yield put(
        setInsertsSuccess(
          transformInsertsDTO(
            inserts,
            insertsPrice.items,
            insertsStockStatus.items,
          ),
        ),
      );
    }
    return yield put(setInsertsSuccess([]));
  } catch (e) {
    yield put(setInsertsFailure(e));
  }
}

export function* insertsSaga() {
  yield takeLatest(actions.setInsertsData.type, setInserts);
}
